import React, {Component} from "react";
import API, {
	AbstractProduct,
	getErrorMessage,
	PaymentProvider,
	PurchaseProductEntry,
	redirectToPaymentPage
} from "../api/API";
import appContext from "../context/AppContext";
import {DataContextConsumer} from "../data/DataContext";
import './PaymentProviderSelectModal.css';

export type PaymentProviderSelectModalData = {

	purchaseParams: {
		playerName: string,
		targetPlayerName: string,
		email: string,
		promoCode?: string,
		entries: PurchaseProductEntry[]
	},
	price: number,
	onBack: () => void

}

const PUBLIC_TERMINAL_ID = 'pk_749c3db2265d76fde61098279b8d1'

type PaymentType = {
	id: string;
	name: string;
	provider: PaymentProvider;
}

const paymentTypes: PaymentType[] = [
	{id: 'card', name: 'Банковская карта', provider: PaymentProvider.TINKOFF},
	{id: 'sbp', name: 'Система быстрых платежей', provider: PaymentProvider.YOOKASSA},
	{id: 'yoo_money', name: 'ЮMoney', provider: PaymentProvider.YOOKASSA},
	{id: 'sberpay', name: 'SberPay', provider: PaymentProvider.YOOKASSA},
	{id: 'tinkoff', name: 'Т-Банк', provider: PaymentProvider.TINKOFF},
	{id: 'world', name: 'Международные карты', provider: PaymentProvider.CLOUD_PAYMENTS}
]

declare global {
	interface Window {
		cp: {
			CloudPayments: new () => any;
		};
	}
}

class PaymentProviderSelectModal extends Component<{data: PaymentProviderSelectModalData}> {

	state = {
		paymentType: paymentTypes[0] as PaymentType,
	}

	render() {
		const {data} = this.props;

		return <DataContextConsumer children={ctx => {
			let availablePaymentTypes = [...paymentTypes];

			if (!ctx.isFromRussia) {
				let crypto = {id: 'crypto', name: 'Криптовалюта', provider: PaymentProvider.TELEGRAM};

				availablePaymentTypes = [...availablePaymentTypes, crypto]
			}

			return <div className="modal payment-provider-select-modal">
				<button className="close" onClick={() => appContext.setPaymentProviderSelectModalData(undefined)}/>

				<h1>Способ оплаты</h1>

				<hr/>

				<div className="sides">
					<div className="left">
						<p>Твой ник:</p>
						<p className="primary">{data.purchaseParams.playerName}</p>

						{data.purchaseParams.playerName === data.purchaseParams.targetPlayerName ? null : <>
							<p>Покупка на ник:</p>
							<p className="primary">{data.purchaseParams.targetPlayerName}</p>
						</>}

						<p>Твоя корзина:</p>
						<p className="primary">
						{data.purchaseParams.entries.map((e, i) => {
							let product: AbstractProduct;

							if (e.setId !== undefined) {
								product = ctx.sets[e.setId!];
							} else {
								product = ctx.products[e.productId!];
							}

							return <div key={i}>- {product.name} x{e.multiplier}</div>;
						})}
						</p>
						<p>Указанная почта:</p>
						<p className="primary">{data.purchaseParams.email}</p>
						<p>Проверь введённые данные.</p>
						<p>Если всё верно — выбери удобный тебе способ оплаты. После оплаты покупка будет выдана на сервере в течение 30 сек.</p>
					</div>

					<div className="right">
						{availablePaymentTypes.map(t => <div key={t.id} className={t.id === this.state.paymentType.id ? 'selected' : ''} onClick={() => this.setState({paymentType: t})}>
							<img src={"https://prostocraft.ru/payment_type_icons/" + t.id + "_" + (t.id === this.state.paymentType.id ? '1' : '0') + ".png"} alt={t.name} title={t.name}/>
						</div>)}
					</div>
				</div>

				<div className="controls">
					<button className="back" onClick={() => {
						appContext.setPaymentProviderSelectModalData(undefined);

						data.onBack();
					}}>Назад</button>
					<button className="buy" onClick={e => this.onClick(e)}>{this.state.paymentType.name}: {data.price} ₽</button>
				</div>

				<hr className="last"/>
			</div>;
		}}/>;
	}

	private onClick(e: any) {
		const params = this.props.data.purchaseParams;

		const button = (e.target as any);

		button.disabled = true;

		API.purchase(
			params.playerName,
			params.targetPlayerName,
			params.email,
			params.promoCode,
			params.entries,
			this.state.paymentType.provider,
			response => {
				button.disabled = false;

				if (response.error) {
					alert(getErrorMessage(response.error));
				} else if (this.state.paymentType.id === 'world' && response.response!.purchaseId) {
					this.launchCloudPaymentsWidget(response.response!.purchaseId, response.response!.price)

				} else {
					redirectToPaymentPage(response.response!.redirectUrl);

				}
			}
		);



	}

	private launchCloudPaymentsWidget(purchaseId: number, price: number): void {
		const { data } = this.props;

		if (window.cp && window.cp.CloudPayments) {
			const widget = new window.cp.CloudPayments();

			const intentParams = {
				publicTerminalId: PUBLIC_TERMINAL_ID,
				amount: price,
				currency: "RUB",
				culture: "ru-RU",
				description: 'Оплата доната на ProstoCraft для ' + data.purchaseParams.playerName,
				externalId: purchaseId,
				paymentSchema: 'Single',
				receiptEmail: data.purchaseParams.email,
				restrictedPaymentMethods: ['TcsInstallment', 'Sbp', 'TinkoffPay', 'MirPay', 'Dolyame'],
				successRedirectUrl: 'https://prostocraft.ru/paymentStatus/success?account=' + purchaseId,
				failRedirectUrl: 'https://prostocraft.ru/paymentStatus/error?account=' + purchaseId,
				emailBehavior: "Hidden",
				retryPayment: true,
				autoClose: 5,
				skin: 'modern'
			};

			widget.start(intentParams).then((widgetResult: any) => {
				console.log('CloudPayments Widget result:', widgetResult);

			}).catch((error: any) => {
				console.error('CloudPayments Widget error:', error);
				alert('Произошла ошибка при запуске виджета оплаты. Пожалуйста, попробуйте снова.');
			});
		} else {
			console.error('CloudPayments Widget script не загружен.');
			alert('Ошибка: скрипт виджета CloudPayments не загружен. Пожалуйста, попробуйте позже.');
		}
	}
}

export default PaymentProviderSelectModal;
